<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-list-legacy [listItems]="itemsListRelated" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="relatedpurchorders_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="70">
                    <tt-list-legacy [listItems]="itemsListRelated" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
